var _path, _circle, _circle2, _path2, _circle3, _circle4, _path3, _circle5, _circle6, _path4, _circle7, _circle8, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmptyMember = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 286,
    viewBox: "0 0 350 286",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1048 75.8597C-22.4153 143.328 53.3732 203.513 98.4574 225.171C161.713 255.56 295.927 268.951 330.768 175.678C369.464 72.0867 107.005 -8.47538 35.1048 75.8597Z",
    fill: "#F4F5F7"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 175.534,
    cy: 101.534,
    r: 27.9847,
    fill: "#FCDF98"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 101.5,
    r: 31.25,
    stroke: "#EF8832",
    strokeWidth: 0.5,
    strokeDasharray: "3 3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M171.889 108.468V107.101C171.889 106.031 172.012 105.098 172.257 104.303C172.503 103.507 172.915 102.763 173.494 102.068C174.072 101.36 174.853 100.622 175.837 99.8558C176.849 99.0604 177.652 98.3735 178.245 97.795C178.852 97.2166 179.286 96.6381 179.546 96.0596C179.821 95.4667 179.958 94.7798 179.958 93.9989C179.958 92.7696 179.539 91.8368 178.7 91.2005C177.876 90.5498 176.712 90.2244 175.208 90.2244C173.877 90.2244 172.626 90.4124 171.455 90.7884C170.283 91.1644 169.127 91.6344 167.984 92.1984L166.184 88.3805C167.5 87.6574 168.924 87.079 170.457 86.6451C172.004 86.1968 173.704 85.9727 175.555 85.9727C178.505 85.9727 180.783 86.6885 182.388 88.1202C184.008 89.5519 184.817 91.4391 184.817 93.7819C184.817 95.069 184.615 96.1753 184.21 97.1009C183.805 98.012 183.205 98.858 182.41 99.6389C181.629 100.405 180.681 101.215 179.568 102.068C178.657 102.792 177.955 103.421 177.464 103.956C176.986 104.476 176.654 105.004 176.466 105.539C176.292 106.074 176.205 106.718 176.205 107.47V108.468H171.889ZM171.064 115.453C171.064 114.267 171.368 113.435 171.975 112.958C172.597 112.466 173.357 112.221 174.253 112.221C175.121 112.221 175.866 112.466 176.488 112.958C177.109 113.435 177.42 114.267 177.42 115.453C177.42 116.61 177.109 117.448 176.488 117.969C175.866 118.475 175.121 118.728 174.253 118.728C173.357 118.728 172.597 118.475 171.975 117.969C171.368 117.448 171.064 116.61 171.064 115.453Z",
    fill: "#EF8832"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.521,
    cy: 174.521,
    r: 17.5213,
    fill: "#B5CBFF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.737,
    cy: 169.585,
    r: 4.51227,
    fill: "#759DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M182.711 181.89C182.711 180.974 182.53 180.067 182.18 179.221C181.829 178.375 181.316 177.606 180.668 176.959C180.021 176.311 179.252 175.797 178.406 175.447C177.56 175.096 176.653 174.916 175.737 174.916C174.821 174.916 173.915 175.096 173.069 175.447C172.222 175.797 171.454 176.311 170.806 176.959C170.159 177.606 169.645 178.375 169.294 179.221C168.944 180.067 168.764 180.974 168.764 181.89L182.711 181.89Z",
    fill: "#759DFF"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.521,
    cy: 174.521,
    r: 17.5213,
    fill: "#B5CBFF"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.737,
    cy: 169.585,
    r: 4.51227,
    fill: "#759DFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M260.711 181.89C260.711 180.974 260.53 180.067 260.18 179.221C259.829 178.375 259.316 177.606 258.668 176.959C258.021 176.311 257.252 175.797 256.406 175.447C255.56 175.096 254.653 174.916 253.737 174.916C252.821 174.916 251.915 175.096 251.069 175.447C250.222 175.797 249.454 176.311 248.806 176.959C248.159 177.606 247.645 178.375 247.294 179.221C246.944 180.067 246.764 180.974 246.764 181.89L260.711 181.89Z",
    fill: "#759DFF"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5213,
    cy: 174.521,
    r: 17.5213,
    fill: "#B5CBFF"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 97.7369,
    cy: 169.585,
    r: 4.51227,
    fill: "#759DFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M104.711 181.89C104.711 180.974 104.53 180.067 104.18 179.221C103.829 178.375 103.316 177.606 102.668 176.959C102.021 176.311 101.252 175.797 100.406 175.447C99.5598 175.096 98.653 174.916 97.7372 174.916C96.8214 174.916 95.9146 175.096 95.0685 175.447C94.2225 175.797 93.4537 176.311 92.8062 176.959C92.1586 177.606 91.645 178.375 91.2945 179.221C90.944 180.067 90.7637 180.974 90.7637 181.89L104.711 181.89Z",
    fill: "#759DFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.5 137.5C176.5 137.224 176.276 137 176 137C175.724 137 175.5 137.224 175.5 137.5H176.5ZM175.5 152C175.5 152.276 175.724 152.5 176 152.5C176.276 152.5 176.5 152.276 176.5 152H175.5ZM175.5 137.5V152H176.5V137.5H175.5Z",
    fill: "#5D5D5D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.5 106H98V152",
    stroke: "#5D5D5D",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M207.5 106H254V152",
    stroke: "#5D5D5D",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyMember, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-member.70007164.svg";
export { ForwardRef as ReactComponent };